import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getQueueMembersSoonLoggedInThreshold } from 'flow/selectors/supervisor-selectors';
import AgentInfoContainer from 'flow/components/pbx/supervisor/sub-components/AgentInfoContainer';
import { getQueueAgentProfileEndTimeExpiringSoon } from 'flow/utils/supervisor-utils';

import { ExtensionKey } from 'flow/types/EntityKeys';
import {
    selectExtensionActiveProfile,
    selectExtensionStatus,
} from 'flow/selectors/ExtensionSelectors';

interface Props {
    agentKey: ExtensionKey;
}

export const SupervisorAgentPopover = ({ agentKey }: Props) => {
    const agentStatus = useAppSelector((state) =>
        selectExtensionStatus(state, agentKey),
    );
    const soonLoggedInThreshold = useAppSelector(
        getQueueMembersSoonLoggedInThreshold,
    );
    const profile = useAppSelector((state) =>
        selectExtensionActiveProfile(state, agentKey),
    );
    const profileEndTime = getQueueAgentProfileEndTimeExpiringSoon(
        profile,
        soonLoggedInThreshold,
    );

    return (
        <div className="p-3">
            <AgentInfoContainer
                extensionKey={agentKey}
                agentStatus={agentStatus}
                profileCurrent={profile}
                profileEndTime={profileEndTime}
                displayedInPopover={true}
            />
        </div>
    );
};

export default SupervisorAgentPopover;
